import { ContextProvider, createContext } from '@lit/context';
import { detectRoot } from '@quandis/qbo4.configuration';
// Bridge the deployment root path into the qbo4.ai context.
// @quandis/qbo4.configuration already provides qboConfigContext ('qbo-config')
// via detectRoot(). AI components consume a separate context key ('qbo4.ai/config')
// with { apiBase? } — provide it here so they resolve correctly under sub-paths.
// A <qbo-config api-base="..."> element closer in the tree takes precedence.
const _aiConfigContext = createContext('qbo4.ai/config');
new ContextProvider(document.documentElement, {
    context: _aiConfigContext,
    initialValue: { apiBase: `${detectRoot()}/ai` }
});
export * from '@quandis/qbo4.configuration';
export * from '@quandis/qbo4.logging';
export * from '@quandis/qbo4.ui';
export * from '@quandis/qbo4.ui-bridge';
export * from '@quandis/qbo4.documents';
export * from '@quandis/qbo4.messages';
export * from '@quandis/qbo4.security';
export * from '@quandis/qbo4.infrastructure.ui';
export { QboConfig, QboAgent, QboChat, QboAiAgentManager, QboAiAgentDocuments } from '@quandis/qbo4.ai';
//# sourceMappingURL=Program.js.map